function performAnimation(item, delay, cl) {
    item.classList.add(cl);
    item.classList.add("active");
    setTimeout(() => {
        item.classList.remove("active");
    }, delay);
}

function fadeInLeft(item, delay) {
    performAnimation(item, delay, "cert-anim-fade-in-left");
}

function fadeInLeftOpaque(item, delay) {
    item.classList.add("cert-opaque")
    fadeInLeft(item, delay);
}

function fadeInBottom(item, delay) {
    performAnimation(item, delay, "cert-anim-fade-in-bottom");
}

function fadeInBottomOpaque(item, delay) {
    item.classList.add("cert-opaque")
    fadeInBottom(item, delay);
}


export default {
    fadeInLeft,
    fadeInBottom,
    fadeInBottomOpaque,
    fadeInLeftOpaque,
}

